"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGenerateCardsDependOnCount = void 0;
var react_1 = require("react");
var useGenerateCardsDependOnCount = function (_a) {
    var cards = _a.cards, cardsPerRow = _a.cardsPerRow;
    return (0, react_1.useMemo)(function () {
        if (!cards || cardsPerRow <= 0)
            return [];
        if (!cardsPerRow || cardsPerRow <= 0)
            return [];
        var total = (cards === null || cards === void 0 ? void 0 : cards.length) || 0;
        if (total === 0)
            return [];
        var fullRows = Math.floor(total / cardsPerRow);
        if (fullRows >= 2)
            return cards === null || cards === void 0 ? void 0 : cards.slice(0, cardsPerRow * Math.min(fullRows, 4));
        if (fullRows === 1)
            return cards.slice(0, cardsPerRow);
        return cards;
    }, [cards, cardsPerRow]);
};
exports.useGenerateCardsDependOnCount = useGenerateCardsDependOnCount;
